import { Directive, ElementRef, OnInit } from '@angular/core';
import { LocalStorageEnum } from '../models/enums/local-storage.enum';
import { LocalStorageService } from '../services/local-storage.service';

@Directive({
  selector: '[appAuthorizedPermission]',
  standalone: true,
})
export class AuthorizedPermissionDirective implements OnInit {
  getUseManagementFee: string | null;

  constructor(
    private _localStorageService: LocalStorageService,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    this.getUseManagementFee = this._localStorageService.get(LocalStorageEnum.use_management_status);
    if (!this.valid()) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }

  valid(): boolean {
    return this.getUseManagementFee === 'true';
  }
}
